"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdRecaptchaFactoryService = void 0;
const rxjs_1 = require("rxjs");
const TpdLogger_service_1 = require("../../providers/TpdLogger.service");
const tpd_recaptcha_response_class_1 = require("./classes/tpd-recaptcha-response.class");
const tpd_recaptcha_class_1 = require("./classes/tpd-recaptcha.class");
const tpd_recaptcha_size_enum_1 = require("./models/tpd-recaptcha-size.enum");
const tpd_recaptcha_status_enum_1 = require("./models/tpd-recaptcha-status.enum");
const tpd_grecaptcha_download_service_1 = require("./tpd-grecaptcha-download.service");
const tpd_recaptcha_site_keys_enum_1 = require("./models/tpd-recaptcha-site-keys.enum");
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const class_1 = require("@tpd-web-common-libs/nodejs-library/dist/src/class");
/**
 * Ex Factory è un semplice service che gestisce la coda dei captcha creati all'interno
 * del componente. Deve essere nel module per essere utilizzato
 *
 * Si appoggia al service platform TpdGrecaptchaDownloadService per il download unico in pagina
 * delle api di google
 */
class TpdRecaptchaFactoryService extends class_1.Singleton {
    constructor() {
        super();
        this.listRecaptcha = new Map();
        this.listExecuteBeforeReady = new Array();
        this.isReady = false;
        this.isWaiting = false;
        this.ID_LOGGER = "TpdRecaptchaFactoryService";
        this.tpdLoggerService = new TpdLogger_service_1.TpdLoggerService();
        this.tpdGrecaptchaDownloadService = new tpd_grecaptcha_download_service_1.TpdGrecaptchaDownloadService(this.tpdLoggerService);
    }
    /**
     * Controlla che il captcha sia abilitato oppure no
     */
    get _isCaptchaEnabled() {
        let esito = true;
        if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()) {
            const href = window.location.href;
            if (href.includes(`qa.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}`) ||
                href.includes(`sit.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}`) ||
                href.includes(`dev.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}`) ||
                href.includes("localhost")) {
                if (href.includes("?captcha=off"))
                    esito = false;
            }
        }
        return esito;
    }
    /**
     * Metodo per la creazione di un captcha accetta i parametri necessari a google per la creazione
     * Restituisce un observable in modo che rimanga in ascolto per la ricezione del token
     *
     * NOTA: in caso di SIZE !== 'invisible' è carico del componente creare un DIV all'interno dell'HTML dove si desidera visualizzare il captcha
     * Nel caso di invisible non conta dove è l'elemento, invece per gli altri SIZE conta perchè l'utente vede il box di google e questo deve essere disposto correttamente in pagina.
     *
     * @param id  - id del DIV di appoggio in caso di invisible viene creato in automatico in caso di non invisible deve essere creato nel componente.html
     * @param siteKey - chiave da utilizzare clientSide, verrà passata a Google in fase di crezione del captcha.
     * @param size - default INVISIBLE - tipo di ReCatcha desiderato
     * @param hidden - default TRUE - nel caso fosse neccesario visualizzare il box in basso a sinistra per l'invisible oppure per size non invisible
     * @returns
     */
    createRecaptcha(id, useProdKey = false, siteKey = tpd_recaptcha_site_keys_enum_1.TpdRecaptchaSiteKeysEnum.INVISIBLE_KEY, // questa chiave è per gli invisible
    size = tpd_recaptcha_size_enum_1.TpdRecaptchaSize.INVISIBLE, hidden = true) {
        if (this.listRecaptcha.has(id)) {
            this.tpdLoggerService.printError(this.ID_LOGGER, `ID non univoco già presente: ${id}`);
        }
        else {
            this.tpdLoggerService.printLog(this.ID_LOGGER, `aggiunto nuovo recaptcha ${id}`);
            const subject = new rxjs_1.Subject();
            const currentUrl = window.location.href;
            if (!useProdKey && (currentUrl.includes('evo-dev.unipol.it') ||
                currentUrl.includes('evo-sit.unipol.it') ||
                currentUrl.includes('evo-dev.unipolsai.it') ||
                currentUrl.includes('evo-sit.unipolsai.it') ||
                currentUrl.includes('dev.unipol.it') ||
                currentUrl.includes('sit.unipol.it') ||
                currentUrl.includes('qa.unipol.it') ||
                currentUrl.includes('fix.unipol.it'))) {
                siteKey = tpd_recaptcha_site_keys_enum_1.TpdRecaptchaSiteKeysEnum.INVISIBLE_KEY_NO_PROD;
            }
            this.listRecaptcha.set(id, new tpd_recaptcha_class_1.TpdRecaptchaClass(size, hidden, siteKey));
            if (this._isCaptchaEnabled) {
                if (this.isReady) {
                    this.renderGrecaptcha(id);
                }
                else if (!this.isWaiting) {
                    this.downloadGoogleAPI();
                }
            }
        }
        const settings = this.listRecaptcha.get(id);
        return settings === null || settings === void 0 ? void 0 : settings.subject.asObservable();
    }
    /**
     * metodo che serve per richiedere la verifica no robot all'utente e di conseguenza il token
     * Questo metodo deve essere lanciato solo quando si utilizza un ReCatpcha di tipo invisibile
     * Se il tutto è READY allora invoca la chiamata a google
     * Altrimenti aggiunge in una coda, appena sarà Ready verrà lanciata tutta la coda in attesa
     * Se l'id passato non è di tipo invisible allora genera un errore.
     * @param id
     */
    executeReCaptcha(id) {
        const settings = this.listRecaptcha.get(id);
        if (settings) {
            if (this._isCaptchaEnabled) {
                if (this.isReady && settings.size === tpd_recaptcha_size_enum_1.TpdRecaptchaSize.INVISIBLE) {
                    this.executeGrecaptcha(id);
                }
                else if (this.isWaiting &&
                    settings.size === tpd_recaptcha_size_enum_1.TpdRecaptchaSize.INVISIBLE) {
                    // google ancora non ha risposto metto in lista di attesa...
                    this.listExecuteBeforeReady.push(id);
                }
                else if (settings.size !== tpd_recaptcha_size_enum_1.TpdRecaptchaSize.INVISIBLE) {
                    this.tpdLoggerService.printError(this.ID_LOGGER, `Only invisible captcha can call execute. ID: ${id}`);
                }
                else {
                    this.tpdLoggerService.printError(this.ID_LOGGER, `Google not init!. ID: ${id}`);
                }
            }
            else {
                this.sendResponse(id, tpd_recaptcha_status_enum_1.TpdRecaptchaStatus.OK);
            }
        }
        else {
            this.tpdLoggerService.printError(this.ID_LOGGER, `ID ${id} not found`);
        }
    }
    /**
     * In caso di errore da parte dei servizi BFF
     * Si può utilizzare questo metodo per effettuare il reset del captcha creato
     * @param id
     */
    resetRecaptcha(id) {
        if (this.listRecaptcha.has(id)) {
            this.tpdLoggerService.printLog(this.ID_LOGGER, `reset captcha: ${id}`);
            this.resetGrecaptcha(id);
        }
        else {
            this.tpdLoggerService.printError(this.ID_LOGGER, `reset captcha, id ${id} not found`);
        }
    }
    /**
     * Da richiamare all'interno del proprio componente nel metodo destroy per
     * cancellare i subscribe, riceve sia singolo id che una lista di id.
     * @param listToDestroy
     */
    destroyIds(listToDestroy) {
        if (typeof listToDestroy === "string") {
            this.deleteRecaptcha(listToDestroy);
        }
        else {
            listToDestroy.forEach((id) => this.deleteRecaptcha(id));
        }
    }
    /**
     * Non si dovrebbe utilizzare questa funzione in quanto ci sono i subscribe
     * che restituiscono il token
     *
     * Recupera il token generato se non c'è non passa nulla
     * @param id
     * @returns
     */
    getResponseRecaptcha(id) {
        if (!this.listRecaptcha.has(id)) {
            this.tpdLoggerService.printError(this.ID_LOGGER, `Recaptcha.getResponseRecaptcha - ID non trovato: ${id}`);
            return new tpd_recaptcha_response_class_1.TpdRecaptchaResponseClass(tpd_recaptcha_status_enum_1.TpdRecaptchaStatus.ERROR, "");
        }
        else {
            const token = this.getResponseGrecaptcha(id);
            if (token) {
                return new tpd_recaptcha_response_class_1.TpdRecaptchaResponseClass(tpd_recaptcha_status_enum_1.TpdRecaptchaStatus.OK, token);
            }
            else {
                return new tpd_recaptcha_response_class_1.TpdRecaptchaResponseClass(tpd_recaptcha_status_enum_1.TpdRecaptchaStatus.EXPIRED, ""); // è una supposizione in questo caso non saprei cosa sia successo
            }
        }
    }
    //#region PRIVATE METHOD
    /**
     * Metodo lanciato solo alla prima richiesta di creazione.
     * Richiama grecaptchaService per un download unico per tutte  le istanze di questo servizio
     * Setta lo stato di READY e WAITING
     * Crea tutti i captcha in lista di attesa per la creazione
     * In caso di elementi in attesa di execute lancia anche quelli con la rispettiva chiamata a google
     */
    downloadGoogleAPI() {
        this.isWaiting = true;
        this.tpdGrecaptchaDownloadService
            .grecaptchaWaitingDownload()
            .subscribe((ready) => {
            if (ready) {
                this.isReady = true;
                this.isWaiting = false;
                this.tpdLoggerService.printLog(this.ID_LOGGER, `starting creation`);
                this.listRecaptcha.forEach((v, k) => {
                    this.renderGrecaptcha(k);
                });
                // Se google risponde dopo tanto tempo ... e possibile che ci siano dei execute in waiting...
                if (this.listExecuteBeforeReady.length > 0) {
                    this.listExecuteBeforeReady.forEach((id) => this.executeGrecaptcha(id)); // la verifica invisible viene già fatta prima.
                }
            }
        });
    }
    /**
     * Effettua il render di google per la creazione del grecaptcha
     * questo viene salvato dentro l'array che contiene tutte le info
     * in automatico crea anche il div che serve a google come appoggio (SOLO in caso invisible)
     * E setta i vari callback
     * @param id
     */
    renderGrecaptcha(id) {
        const settings = this.listRecaptcha.get(id);
        // gestione del caso in cui non sia presente nella mappa
        if (!settings) {
            this.tpdLoggerService.printError(this.ID_LOGGER, `ID ${id} not found`);
            return;
        }
        if (settings.size === tpd_recaptcha_size_enum_1.TpdRecaptchaSize.INVISIBLE) {
            if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide()) {
                const oldElement = document.getElementById(id);
                if (oldElement)
                    oldElement.remove();
            }
            const element = document.createElement("div");
            element.setAttribute("id", id);
            if (settings.hidden) {
                element.setAttribute("hidden", "true");
            }
            if (typeof document === "object") {
                document.body.appendChild(element);
            }
        }
        try {
            settings.recaptcha = grecaptcha.render(id, {
                sitekey: settings.siteKey,
                size: settings.size,
                callback: (token) => {
                    this.sendResponse(id, tpd_recaptcha_status_enum_1.TpdRecaptchaStatus.OK, token);
                },
                "expired-callback": () => {
                    this.sendResponse(id, tpd_recaptcha_status_enum_1.TpdRecaptchaStatus.EXPIRED);
                },
                "error-callback": () => {
                    this.sendResponse(id, tpd_recaptcha_status_enum_1.TpdRecaptchaStatus.ERROR);
                },
            });
            this.listRecaptcha.set(id, settings);
        }
        catch (e) {
            console.error("Errore recaptcha", String(e));
        }
        this.tpdLoggerService.printLog(this.ID_LOGGER, `creazione completata per ${id}`);
    }
    sendResponse(id, status, token) {
        this.tpdLoggerService.printLog(this.ID_LOGGER, `call sendResponse ${id}, status: ${status}, token: ${token}`);
        const settings = this.listRecaptcha.get(id);
        if (!settings) {
            this.tpdLoggerService.printError(this.ID_LOGGER, `ID ${id} not found`);
            return;
        }
        settings.subject.next(new tpd_recaptcha_response_class_1.TpdRecaptchaResponseClass(status, token ? token : ""));
    }
    /**
     * Metodo google execute solo per invisible
     * @param id
     */
    executeGrecaptcha(id) {
        const settings = this.listRecaptcha.get(id);
        if (!settings) {
            this.tpdLoggerService.printError(this.ID_LOGGER, `ID ${id} not found`);
            return;
        }
        grecaptcha.execute(settings.recaptcha);
    }
    /**
     * Metodo google reset
     * @param id
     */
    resetGrecaptcha(id) {
        const settings = this.listRecaptcha.get(id);
        if (!settings) {
            this.tpdLoggerService.printError(this.ID_LOGGER, `ID ${id} not found`);
            return;
        }
        grecaptcha.reset(settings.recaptcha);
    }
    /**
     * Metodo interno delete completo dell'elemento passato
     * @param id
     */
    deleteRecaptcha(id) {
        var _a;
        const settings = this.listRecaptcha.get(id);
        if (!settings) {
            this.tpdLoggerService.printError(this.ID_LOGGER, `ID ${id} not found`);
            return;
        }
        (_a = settings.subject) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.listRecaptcha.delete(id);
    }
    /**
     * Metodo google recupera la risposta se il token è ancora valido restituisce il token
     * @param id
     * @returns
     */
    getResponseGrecaptcha(id) {
        const settings = this.listRecaptcha.get(id);
        if (!settings) {
            this.tpdLoggerService.printError(this.ID_LOGGER, `ID ${id} not found`);
            return;
        }
        return grecaptcha.getResponse(settings.recaptcha);
    }
}
exports.TpdRecaptchaFactoryService = TpdRecaptchaFactoryService;
TpdRecaptchaFactoryService.className = "TpdRecaptchaFactoryService";
